module.exports = __webpack_public_path__ + "img/t4-6.f15bfaea.svg";